// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"513":"459e2558","777":"2669e9ed"}[chunkId] + ".chunk.css";
};